module.exports = __webpack_public_path__ + "img/user_index_page_bg.cb14973d.png";